import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../helpers/AuthContext'; // Chemin correct vers votre AuthContext
import { toast } from 'react-toastify';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const navigate = useNavigate();
  const { login } = useContext(AuthContext); // Utilisation de la fonction login du contexte

  const usernameHandleChange = (e) => {
    setUsername(e.target.value);
  };

  const passwordHandleChange = (e) => {
    setPassword(e.target.value);
  };
  //  toast.info('Vous devez vous connecté');
  const handleLogin = async () => {
    try {
      await login(username, password); // Appel de la fonction login depuis AuthContext
      //navigate('/'); // Redirection après connexion réussie
    } catch (error) {
      toast.error(`Erreur lors de la connexion:, ${error.message}`);
    }
  };

  return (
    <div className="container mt-5 pt-5">
      <div className="col-md-6 mx-auto bg-info p-5 rounded-lg">
        <div className="row">
          <div className="col text-center">
            <h1>Authentification</h1>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <label htmlFor="login">Login</label>
            <input id="username" name="username" type="text" className="form-control" onChange={usernameHandleChange} autoComplete="off" />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <label htmlFor="login">Mot de passe</label>
            <input id="password" name="password" type="password" className="form-control" onChange={passwordHandleChange} />
          </div>
        </div>
        <div className="row">
          <div className="col mt-3">
            <button onClick={handleLogin} className="btn btn-success">
              Connecté
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
